module.exports = __webpack_public_path__ + "Roboto-Light.8e0860f3581b197e9fa4.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Light.woff2
// module id = 139
// module chunks = 10